import { TProgressProps } from 'types'
import { StyleSheetManager } from 'styled-components'

import * as S from './styles'

const ProgressBar = ({ num, totalSteps }: TProgressProps) => (
  <StyleSheetManager shouldForwardProp={(prop) => prop !== 'num' && prop !== 'totalSteps'}>
    <S.Container data-testid="progressBar">
      <S.Progress num={num} totalSteps={totalSteps} data-testid="progressBarBlank" />
      <S.ProgressBack num={totalSteps - num} totalSteps={totalSteps} data-testid="progressColor" />
    </S.Container>
  </StyleSheetManager>
)
export default ProgressBar
